/**
 * 상품 상세 조회 커스텀 훅
 *
 * react-query를 사용하여 상품 상세 데이터를 fetch하고 캐싱
 * - 자동 리페칭 및 캐시 관리
 * - 로딩/에러 상태 관리
 */

import { useQuery } from "@tanstack/react-query";
import { getProductDetail } from "../api/productApi";

/**
 * 상품 상세 조회 훅
 *
 * @param productId - 상품 ID
 * @param options - react-query 옵션 (enabled 등)
 * @returns react-query의 useQuery 결과 (data, isLoading, isError 등)
 */
export const useProductDetail = (
  productId: number,
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: ["product", productId],
    queryFn: () => getProductDetail(productId),
    enabled: options?.enabled !== false && productId > 0,
    staleTime: 0, // 항상 최신 데이터 조회
    gcTime: 1000 * 60 * 10, // 10분간 가비지 컬렉션 유예
  });
};

